<script>
    import CardCinema from "../components/CardCinema.svelte";
    import { onMount } from "svelte";

    let { data } = $props();
    const { recommendations, headline, featuresState, additionalClickTracking, tracking, hasPersonalisedRecommendations = false } = data;

    const site = "reco_brand";

    let hasElevationLevel = ![null, undefined, ""].includes(headline);

    let index = $state("0");
    let cinemaInjectionContainerWidth = $state(1000);
    let featureIndex = $state("99");
    let additionalTrackingLabels = $state(null);
    let cinemaContainer;
    let additionalNextPiTrackingLabels = $state(null);
    let mountSuccess;
    let cinemaContainerMounted = new Promise((resolve) => {
        mountSuccess = resolve;
    });

    onMount(() => {
        featureIndex = cinemaContainer?.parentElement?.dataset?.featureOrder || "99";
        additionalTrackingLabels = JSON.parse(cinemaContainer?.parentElement?.dataset?.featureTrackingLabels || null);
        additionalNextPiTrackingLabels = JSON.parse(cinemaContainer?.parentElement?.dataset?.nextPiTrackingLabels || null);
        cinemaInjectionContainerWidth = parseInt(cinemaContainer?.offsetWidth) || 1000;
        mountSuccess();
    });
</script>

<div bind:this={cinemaContainer}>
    <div class="reco_card_cinema_wrapper">
        <CardCinema
            {headline}
            {recommendations}
            {cinemaInjectionContainerWidth}
            {additionalClickTracking}
            {featuresState}
            {featureIndex}
            cinemaIndex={index}
            {additionalNextPiTrackingLabels}
            {additionalTrackingLabels}
            {tracking}
            personalisedUser={hasPersonalisedRecommendations}
            {site}
            {hasElevationLevel}
            {cinemaContainerMounted}
        />
    </div>
</div>

<style lang="scss">
    .reco_card_cinema_wrapper {
        max-height: 672px;
        position: relative;
    }
</style>
